import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import rcsSupplierInfoTableMapping from './RcsSupplierInfoTableMapping';

import './RcsSupplierInfoTable.scss';

export default function RcsSupplierInfoTable(props) {
  const { supplierInfo = Map({}), handleWebAddressClick, disableAATracking } = props;

  return (
    <table
      aria-label="Supplier information"
      aria-describedby="supplier-information-table-description"
      className="rcs-supplier-info-table table c-els-table c-els-table--vertical-dividers c-els-table--subtle-dividers c-els-table--padding-1o2"
      id="supplier-information">
      <caption className="c-els-table__caption u-els-hide-visually" id="supplier-information-table-description">
        Table containing supplier information data
      </caption>
      <tbody className="table__body c-els-table__body">
        {rcsSupplierInfoTableMapping.map(([name, getDefinition]) => (
          <tr className="table__row c-els-table__row" key={name}>
            <th scope="row" className="table__cell c-els-table__cell u-els-font-family-base">
              {name}
            </th>
            <td className="table__cell c-els-table__cell">{getDefinition(supplierInfo, handleWebAddressClick, disableAATracking)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

RcsSupplierInfoTable.propTypes = {
  supplierInfo: PropTypes.instanceOf(Map),
  handleWebAddressClick: PropTypes.func,
  disableAATracking: PropTypes.bool,
};
